document
  .querySelectorAll("[data-sc-configurator]:not([data-sc-ready])")
  .forEach((t) => {
    t.dataset.scReady = "true";
    const e = (e) => t.querySelector(e),
      i = (e) => [...t.querySelectorAll(e)],
      a = e("[data-sc-wall]"),
      n = e("[data-sc-stage]"),
      s = JSON.parse(e("[data-sc-variants]").textContent),
      o = Object.fromEntries(
        i("[data-sc-add]").map((t) => [t.dataset.scAdd, t.dataset.scPattern]),
      ),
      designLabels = Object.fromEntries(
        i("[data-sc-add]").map((t) => [t.dataset.scAdd, t.dataset.scLabel]),
      ),
      l = {
        wallWidth: 360,
        wallHeight: 240,
        renderScale: 2,
        color: { name: "Light Beige", hex: "#bbb4ac" },
        tiles: [],
        selected: null,
        history: [],
      };
    function d() {
      return l.renderScale;
    }
    function c(t) {
      const e = d(),
        i = t.rotation % 180 != 0;
      return {
        width: (i ? 60 : 120) * e,
        height: (i ? 120 : 60) * e,
        baseWidth: 120 * e,
        baseHeight: 60 * e,
      };
    }
    function r(t, e, i, a) {
      const n = { left: t, right: t + i.width, top: e, bottom: e + i.height };
      return l.tiles.some((t) => {
        if (t.uid === a) return !1;
        const e = c(t);
        return (function (t, e) {
          const i = 0.5;
          return (
            t.left < e.right - i &&
            t.right > e.left + i &&
            t.top < e.bottom - i &&
            t.bottom > e.top + i
          );
        })(n, {
          left: t.x,
          right: t.x + e.width,
          top: t.y,
          bottom: t.y + e.height,
        });
      });
    }
    function h(t) {
      const e = c(t),
        i = l.wallWidth * d(),
        a = l.wallHeight * d();
      return (
        t.x < -2 || t.y < -2 || t.x + e.width > i + 2 || t.y + e.height > a + 2
      );
    }
    function u() {
      (l.history.push(JSON.stringify(l.tiles)),
        l.history.length > 30 && l.history.shift());
    }
    function g(t, e) {
      u();
      const i = {
          uid: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
          design: t,
          pattern: o[t],
          color: l.color.hex,
          x: e?.x || 0,
          y: e?.y || 0,
          rotation: e?.rotation || 0,
        },
        n = (function (t) {
          const e = c(t),
            i = 60 * d(),
            n = Math.max(0, a.clientWidth - e.width),
            s = Math.max(0, a.clientHeight - e.height);
          for (let a = 0; a <= s + 0.5; a += i)
            for (let s = 0; s <= n + 0.5; s += i)
              if (!r(s, a, e, t.uid)) return { x: s, y: a };
          let o = a.clientHeight;
          for (; r(0, o, e, t.uid);) o += i;
          return { x: 0, y: o };
        })(i);
      ((i.x = n.x), (i.y = n.y), l.tiles.push(i), (l.selected = i.uid), m());
    }
    function p() {
      const t = l.tiles.find((t) => t.uid === l.selected);
      const selectedProduct = e("[data-sc-selected-product]"),
        selectedSurface = e("[data-sc-selected-surface]");
      if (t) {
        selectedProduct.hidden = false;
        selectedSurface.style.setProperty("--sc-selected-color", l.color.hex);
        selectedSurface.style.setProperty(
          "--sc-selected-pattern",
          `url("${t.pattern}")`,
        );
      } else {
        selectedProduct.hidden = true;
      }
      ((e("[data-sc-selection]").textContent = t
        ? `Curvy ${designLabels[t.design]} | 120 × 60 cm | ${l.color.name}`
        : "Nog geen tegel geselecteerd"),
        a.querySelectorAll(".sc-tile").forEach((t) => {
          t.classList.toggle("is-selected", t.dataset.uid === l.selected);
        }),
        i("[data-sc-add]").forEach((button) => {
          button.classList.toggle("is-active", button.dataset.scAdd === t?.design);
        }));
    }
    function f(t = "A1") {
      return s.find(
        (e) =>
          e.available &&
          e.options.includes(l.color.name) &&
          e.options.includes(t),
      );
    }
    function m() {
      (a.querySelectorAll(".sc-tile").forEach((t) => t.remove()),
        l.tiles.forEach((t) => {
          const i = c(t),
            n = document.createElement("div");
          ((n.className = `sc-tile${t.uid === l.selected ? " is-selected" : ""}${h(t) ? " is-overhang" : ""}`),
            (n.dataset.uid = t.uid),
            (n.style.left = `${t.x}px`),
            (n.style.top = `${t.y}px`),
            (n.style.width = `${i.width}px`),
            (n.style.height = `${i.height}px`));
          const s = document.createElement("div");
          ((s.className = "sc-tile-surface"),
            s.style.setProperty("--sc-color", l.color.hex),
            s.style.setProperty("--sc-pattern", `url("${t.pattern}")`),
            s.style.setProperty("--sc-rotation", `${t.rotation}deg`),
            (s.style.width = `${i.baseWidth}px`),
            (s.style.height = `${i.baseHeight}px`),
            t.rotation % 180 != 0 &&
              ((s.style.left = (i.width - i.baseWidth) / 2 + "px"),
              (s.style.top = (i.height - i.baseHeight) / 2 + "px")),
            n.append(s),
            a.append(n),
            (function (t, i) {
              t.addEventListener("pointerdown", (n) => {
                (u(), (l.selected = i.uid), p());
                const s = n.clientX,
                  o = n.clientY,
                  g = i.x,
                  f = i.y;
                t.setPointerCapture(n.pointerId);
                const y = (n) => {
                    const u = c(i),
                      p = 60 * d(),
                      m = 16,
                      y = Math.min(34, Math.max(18, 0.22 * p));
                    let w = g + n.clientX - s,
                      b = f + n.clientY - o;
                    const x = Math.round(w / p) * p,
                      v = Math.round(b / p) * p;
                    (Math.abs(w - x) <= y && (w = x),
                      Math.abs(b - v) <= y && (b = v));
                    const E = a.clientWidth - u.width,
                      L = a.clientHeight - u.height;
                    (Math.abs(w) <= m && (w = 0),
                      Math.abs(w - E) <= m && (w = E),
                      Math.abs(b) <= m && (b = 0),
                      Math.abs(b - L) <= m && (b = L),
                      l.tiles
                        .filter((t) => t.uid !== i.uid)
                        .forEach((t) => {
                          const e = c(t),
                            i = {
                              left: w,
                              right: w + u.width,
                              top: b,
                              bottom: b + u.height,
                            },
                            a = {
                              left: t.x,
                              right: t.x + e.width,
                              top: t.y,
                              bottom: t.y + e.height,
                            },
                            n = i.bottom > a.top - m && i.top < a.bottom + m,
                            s = i.right > a.left - m && i.left < a.right + m;
                          (n && Math.abs(i.left - a.right) <= m
                            ? (w = a.right)
                            : n &&
                              Math.abs(i.right - a.left) <= m &&
                              (w = a.left - u.width),
                            s && Math.abs(i.top - a.bottom) <= m
                              ? (b = a.bottom)
                              : s &&
                                Math.abs(i.bottom - a.top) <= m &&
                                (b = a.top - u.height));
                        }),
                      r(w, b, u, i.uid) ||
                        ((i.x = w),
                        (i.y = b),
                        (t.style.left = `${w}px`),
                        (t.style.top = `${b}px`),
                        t.classList.toggle("is-overhang", h(i)),
                        e("[data-sc-cut-note]").classList.toggle(
                          "is-visible",
                          l.tiles.some(h),
                        )));
                  },
                  w = () => {
                    (t.removeEventListener("pointermove", y),
                      t.removeEventListener("pointerup", w),
                      m());
                  };
                (t.addEventListener("pointermove", y),
                  t.addEventListener("pointerup", w));
              });
            })(n, t));
        }));
      const t = f(l.tiles[0]?.design || "A1");
      var i;
      ((e("[data-sc-count]").textContent = l.tiles.length),
        (e("[data-sc-area]").textContent =
          `${(0.72 * l.tiles.length).toFixed(2).replace(".", ",")} m²`),
        (e("[data-sc-price]").textContent =
          ((i = (t?.price || 0) * l.tiles.length),
          new Intl.NumberFormat("nl-NL", {
            style: "currency",
            currency: "EUR",
          }).format(i / 100))),
        e("[data-sc-cut-note]").classList.toggle("is-visible", l.tiles.some(h)),
        (e("[data-sc-add-cart]").disabled =
          !l.tiles.length || l.tiles.some((t) => !f(t.design))),
        p());
    }
    function y() {
      ((l.wallWidth = Math.max(
        100,
        Number(e("[data-sc-wall-width]").value) || 360,
      )),
        (l.wallHeight = Math.max(
          60,
          Number(e("[data-sc-wall-height]").value) || 240,
        )));
      const t = Math.min(760, n.clientWidth - 110),
        i = Math.min(520, n.clientHeight - 130);
      if (t <= 0 || i <= 0) return;
      const s = Math.min(t / l.wallWidth, i / l.wallHeight);
      ((l.renderScale = s),
        (a.style.width = l.wallWidth * s + "px"),
        (a.style.height = l.wallHeight * s + "px"),
        (e("[data-sc-width-label]").textContent = `${l.wallWidth} cm`),
        (e("[data-sc-height-label]").textContent = `${l.wallHeight} cm`),
        m());
    }
    (i("[data-sc-add]").forEach((t) =>
      t.addEventListener("pointerdown", (e) => {
        0 === e.button && (e.preventDefault(), g(t.dataset.scAdd));
      }),
    ),
      i("[data-sc-color]").forEach((t) =>
        t.addEventListener("click", () => {
          (u(),
            (l.color = { name: t.dataset.scColor, hex: t.dataset.scHex }),
            i("[data-sc-color]").forEach((e) =>
              e.classList.toggle("is-active", e === t),
            ),
            (e("[data-sc-color-name]").textContent = l.color.name),
            m());
        }),
      ),
      e("[data-sc-rotate]").addEventListener("click", () => {
        const t = l.tiles.find((t) => t.uid === l.selected);
        if (!t) return;
        u();
        const e = t.rotation;
        ((t.rotation = (t.rotation + 90) % 360),
          r(t.x, t.y, c(t), t.uid) && (t.rotation = e),
          m());
      }),
      e("[data-sc-duplicate]").addEventListener("click", () => {
        const t = l.tiles.find((t) => t.uid === l.selected);
        t && g(t.design, t);
      }),
      e("[data-sc-delete]").addEventListener("click", () => {
        l.selected &&
          (u(),
          (l.tiles = l.tiles.filter((t) => t.uid !== l.selected)),
          (l.selected = null),
          m());
      }),
      e("[data-sc-deselect]").addEventListener("click", () => {
        ((l.selected = null), p());
      }),
      a.addEventListener("pointerdown", (t) => {
        t.target === a && ((l.selected = null), p());
      }),
      document.addEventListener("keydown", (t) => {
        "Escape" === t.key && ((l.selected = null), p());
      }),
      e("[data-sc-undo]").addEventListener("click", () => {
        const t = l.history.pop();
        t && ((l.tiles = JSON.parse(t)), (l.selected = null), m());
      }),
      e("[data-sc-reset]").addEventListener("click", () => {
        (u(), (l.tiles = []), (l.selected = null), m());
      }),
      i("[data-sc-wall-width], [data-sc-wall-height]").forEach((t) =>
        t.addEventListener("change", y),
      ),
      e("[data-sc-add-cart]").addEventListener("click", async () => {
        const t = e("[data-sc-add-cart]"),
          i = e("[data-sc-cart-message]");
        if (!l.tiles.length) return;
        ((t.disabled = !0), (i.textContent = "Je ontwerp wordt toegevoegd..."));
        const a = l.tiles.reduce(
            (t, e) => (
              t[e.design] || (t[e.design] = []),
              t[e.design].push(e),
              t
            ),
            {},
          ),
          n = Object.entries(a).map(([t, e]) => {
            const i = f(t);
            return {
              id: i?.id,
              quantity: e.length,
              properties: { SKU: i?.sku || "" },
            };
          });
        if (n.some((t) => !t.id))
          return (
            (t.disabled = !1),
            void (i.textContent =
              "Deze combinatie is nog niet bestelbaar. Kies een andere tegel of kleur.")
          );
        try {
          if (
            !(
              await fetch(`${window.Shopify?.routes?.root || "/"}cart/add.js`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/json",
                },
                body: JSON.stringify({ items: n }),
              })
            ).ok
          )
            throw new Error("Cart request failed");
          ((i.textContent = "Je ontwerp is toegevoegd."),
            (window.location.href = `${window.Shopify?.routes?.root || "/"}cart`));
        } catch (e) {
          ((t.disabled = !1),
            (i.textContent = "Toevoegen lukte niet. Probeer het nogmaals."));
        }
      }));
    const w = () => {
      n.clientWidth && (y(), l.tiles.length ? m() : g("A1"));
    };
    (requestAnimationFrame(() => requestAnimationFrame(w)),
      window.addEventListener("load", w, { once: !0 }),
      new ResizeObserver(w).observe(n));
  });
